//Cancel out the annoying formats for the phone-number
//https://stackoverflow.com/questions/3736807/how-do-i-remove-the-blue-styling-of-telephone-numbers-on-iphone-ios
export const meta = (meta) => {
  meta.addMetaItem([
    //<meta name="format-detection" content="telephone=no">
    { name:'format-detection', content: 'telephone=no' },
  ])
}

export const extraJS = null

//We need to include this. There should be a separate one for 
//https://csswizardry.com/2020/05/the-fastest-google-fonts/

export const externalCSS = [
  // {type:'webfont', href:'https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;900'},
  // {type:'webfont', href:'https://fonts.googleapis.com/css2?family=Source+Serif+Pro:wght@700&display=swap'},
  // {type:'webfont', href:"https://fonts.googleapis.com/css2?family=Oswald:wght@500&display=swap"},
  //{ type:'css', href:'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css' },
  { type:'webfont', href:"https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap" },
  { type:'webfont', href:"https://fonts.googleapis.com/css?family=Overpass%3A400%2C400i%2C700&ver=6.8.2" },
  { type:'css', href:"https://use.typekit.net/qrn0pdk.css" }
]

